import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "flex flex-wrap gap-2" }
const _hoisted_2 = ["title"]

import { LockClosedIcon, TrophyIcon } from '@heroicons/vue/24/outline'
import { computed } from 'vue'
import { RouterLink } from 'vue-router'

import { formatDay, milestoneGroups } from './marketingSeries'

const LOCKED_SHOWN = 2


export default {
  __name: 'MarketingMilestones',
  props: {
  milestones: { type: Array, default: () => [] },
  compact: { type: Boolean, default: false }
},
  setup(__props) {

const props = __props
const groups = computed(() => milestoneGroups(props.milestones))
const shown = computed(() => [
  ...groups.value.earned,
  ...(props.compact ? groups.value.locked.slice(0, LOCKED_SHOWN) : groups.value.locked)
])
const hiddenCount = computed(() => (props.milestones || []).length - shown.value.length)

return (_ctx, _cache) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(shown.value, (m) => {
      return (_openBlock(), _createElementBlock("span", {
        key: m.key,
        "data-badge": "",
        class: _normalizeClass(["inline-flex items-center gap-1 text-xs font-bold rounded-lg px-2 py-1", m.earned_at ? 'bg-green-100 text-green-800' : 'bg-gray-100 text-gray-600']),
        title: m.earned_at ? `Earned ${_unref(formatDay)(m.earned_at)}` : 'Not yet'
      }, [
        (m.earned_at)
          ? (_openBlock(), _createBlock(_unref(TrophyIcon), {
              key: 0,
              class: "h-3.5 w-3.5",
              "aria-hidden": "true"
            }))
          : (_openBlock(), _createBlock(_unref(LockClosedIcon), {
              key: 1,
              class: "h-3.5 w-3.5",
              "aria-hidden": "true"
            })),
        _createTextVNode(" " + _toDisplayString(m.label), 1)
      ], 10, _hoisted_2))
    }), 128)),
    (__props.compact && hiddenCount.value > 0)
      ? (_openBlock(), _createBlock(_unref(RouterLink), {
          key: 0,
          to: "/marketing/performance",
          class: "text-xs underline text-gray-600 self-center"
        }, {
          default: _withCtx(() => [...(_cache[0] || (_cache[0] = [
            _createTextVNode(" See all ", -1)
          ]))]),
          _: 1
        }))
      : _createCommentVNode("", true)
  ]))
}
}

}